'use strict';

var _ = require('lodash');
var FaresOptimizerAnalysisOptionsConfigurationService = function FaresOptimizerAnalysisOptionsConfigurationService(configurationService, FaresOptimizerConstants) {
  var DEFAULT_GROUP_BY_ITEMS = ['Host Carrier', 'Market'];
  var DEFAULT_CONST = '(default)';
  var SORT_BY_ITEMS = [{
    field: 'carrier',
    label: 'Host Carrier',
    order: 'asc'
  }, {
    field: 'marketTier',
    label: 'Market Tier',
    order: 'asc'
  }, {
    field: 'recommendationCount',
    label: 'Number of Recommendations',
    order: 'desc'
  }, {
    field: 'avgAbsoluteFareChange',
    label: 'Avg % Fare Change',
    order: 'desc'
  }];
  var GROUP_BY_ITEMS = [{
    field: 'carrier',
    label: 'Host Carrier'
  }, {
    field: 'market',
    label: 'Market'
  }, {
    field: 'cabin',
    label: 'Cabin'
  }, {
    field: 'season',
    label: 'Season'
  }, {
    field: 'dow',
    label: 'Dow Group'
  }, {
    field: 'apGroup',
    label: 'AP Group'
  }, {
    field: 'fareBrandName',
    label: 'Host Fare Brand'
  }];
  function isDefaultGroupByItem(defaultGroupByItems, item) {
    return _.includes(defaultGroupByItems, item);
  }
  function getGroupByFilter() {
    var groupByItems = _.chain(GROUP_BY_ITEMS).map('label').uniq().value();
    return {
      groupById: 'groupBy',
      type: FaresOptimizerConstants.TYPE_CHECKBOX,
      options: _.map(groupByItems, function (item) {
        return {
          value: item,
          label: isDefaultGroupByItem(DEFAULT_GROUP_BY_ITEMS, item) ? item + ' ' + DEFAULT_CONST : item,
          disableStatus: isDefaultGroupByItem(DEFAULT_GROUP_BY_ITEMS, item)
        };
      })
    };
  }
  function getFirstLevelSortByItems() {
    var sortBy_combobox_values = _.chain(SORT_BY_ITEMS).map('label').uniq().value();
    return {
      sortById: 'firstLevelSortBy',
      title: 'Sort By',
      type: FaresOptimizerConstants.TYPE_COMBOBOX,
      options: sortBy_combobox_values,
      placeholder: sortBy_combobox_values[0]
    };
  }
  function getSecondLevelSortByItems() {
    var sortBy_combobox_values = _.chain(SORT_BY_ITEMS).map('label').uniq().value();
    return {
      sortById: 'secondLevelSortBy',
      title: 'Then By',
      type: FaresOptimizerConstants.TYPE_COMBOBOX,
      options: sortBy_combobox_values,
      placeholder: sortBy_combobox_values[1]
    };
  }
  function getThirdLevelSortByItems() {
    var sortBy_combobox_values = _.chain(SORT_BY_ITEMS).map('label').uniq().value();
    return {
      sortById: 'thirdLevelSortBy',
      title: 'Then By',
      type: FaresOptimizerConstants.TYPE_COMBOBOX,
      options: sortBy_combobox_values,
      placeholder: sortBy_combobox_values[2]
    };
  }
  function getFourthLevelSortByItems() {
    var sortBy_combobox_values = _.chain(SORT_BY_ITEMS).map('label').uniq().value();
    return {
      sortById: 'fourthLevelSortBy',
      title: 'Then By',
      type: FaresOptimizerConstants.TYPE_COMBOBOX,
      options: sortBy_combobox_values,
      placeholder: sortBy_combobox_values[3]
    };
  }
  function loadGroupByItemsFromConfig() {
    return _.concat([], getGroupByFilter());
  }
  function loadSortByItemsFromConfig() {
    return _.concat([], getFirstLevelSortByItems(), getSecondLevelSortByItems(), getThirdLevelSortByItems(), getFourthLevelSortByItems());
  }
  var toggleButtons = [{
    value: 'asc',
    styleName: 'icon-asc'
  }, {
    value: 'desc',
    styleName: 'icon-desc'
  }];
  function getToggleButtons() {
    return _.cloneDeep(toggleButtons);
  }
  function getGroupByItems() {
    return _.cloneDeep(GROUP_BY_ITEMS);
  }
  function getSortByItems() {
    return _.cloneDeep(SORT_BY_ITEMS);
  }
  return {
    loadGroupByItemsFromConfig: loadGroupByItemsFromConfig,
    loadSortByItemsFromConfig: loadSortByItemsFromConfig,
    getToggleButtons: getToggleButtons,
    getGroupByItems: getGroupByItems,
    getSortByItems: getSortByItems
  };
};
FaresOptimizerAnalysisOptionsConfigurationService.$inject = ['ConfigurationService', 'FaresOptimizerConstants'];
module.exports = FaresOptimizerAnalysisOptionsConfigurationService;